/*
 *
 * GenericModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
*/

import { connect } from 'react-redux'
import DeleteCartItemModal from './DeleteCartItemModal'
import { nullSafe } from 'Utility/globalMethods'

const mapStateToProps = state => ({
  product: nullSafe(() => state.popup.popupInfo.product, {}),
  title: nullSafe(() => state.popup.popupInfo.title, ''),
  onClose: nullSafe(() => state.popup.popupInfo.onClose, () => { }),
  primaryButtonLabel: nullSafe(() => state.popup.popupInfo.primaryButtonLabel, ''),
  secondaryButtonLabel: nullSafe(() => state.popup.popupInfo.secondaryButtonLabel, ''),
  secondaryAction: nullSafe(() => state.popup.popupInfo.secondaryAction, () => { }),
  primaryAction: nullSafe(() => state.popup.popupInfo.primaryAction, () => { })
})

export default connect(mapStateToProps, null, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(DeleteCartItemModal)
